<template>
  <!-- 活动信息买赠 -->
  <div class="con">
    <van-action-sheet v-model="show" title="取消订单" @close="close">
      <div class="content border_top1px text_left">
        <div class="font14 font_weight500 colo0 title_bor">
          请选择取消订单原因：
        </div>
        <div
          v-for="(item, index) in refundReasionList"
          :key="index"
          class="total_price clearfix"
        >
          <div
            :class="{ bor_line_line: index !== 0 }"
            class="bor_line"
            @click.stop="chooseItemRefundReasion(index, item)"
          >
            <span
              class="font12 font_weight400 colo087 line_height_17 bor_item"
              >{{ item }}</span
            >
            <img
              :src="index === refundReasionIndex ? chooseDialogPic : dialogPic"
              alt=""
              class="left go_right"
            />
          </div>
        </div>
        <div
          :class="refundReasionIndex > -1 ? 'btn_color' : 'btn_none_color'"
          class="font14 font_weight500 colof line_height_40 text_center btn"
          @click.stop="confirmReasion"
        >
          确认
        </div>
      </div>
    </van-action-sheet>
  </div>
</template>
<script>
export default {
  // props: {
  //   show: {
  //     type: Boolean,
  //     default: true
  //   }
  // },
  data() {
    return {
      show: true,
      refundReasionList: [
        "不想要了",
        "商品信息填写有错误",
        "地址信息有误",
        "商品降价",
        "其他"
      ],
      refundReasionIndex: -1,
      dialogPic: require("@/assets/login/unselect_icon@2x.png"),
      chooseDialogPic: require("@/assets/login/select@2x.png"),
      reasion: ""
    };
  },
  methods: {
    close() {
      this.show = true;
      this.$emit("closeSheet");
    },
    // 选择退款原因
    chooseItemRefundReasion(index, item) {
      // this.$emit("closeSheet");
      this.reasion = item;
      this.refundReasionIndex = index;
    },
    confirmReasion() {
      this.$emit("confirmReasion", this.reasion);
    }
  }
};
</script>

<style lang="less" scoped>
.con {
  background: #fff;
  .content {
    padding: 16px 12px 7px;
    .total_price {
      font-size: 0;
      margin-bottom: 17px;
    }
    .go_right {
      width: 18px;
      margin-right: 12px;
      vertical-align: middle;
    }
    .bor_item {
      vertical-align: middle;
    }
    .title_bor {
      margin-bottom: 25px;
    }
  }
  .btn {
    border-radius: 20px;
    margin-top: 135px;
  }
  .btn_none_color {
    background: linear-gradient(90deg, #e1c49d 0%, #bf9264 100%);
    opacity: 0.5;
  }
  .btn_color {
    background: linear-gradient(90deg, #e1c49d 0%, #bf9264 100%);
  }
}
</style>
